import type { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  appUiUrl: 'https://app.csrd.halfserious.com/',
  appApiUrl: 'https://api.app.csrd.halfserious.com',
  refreshTokensTimerDue: 5 * 60 * 1000, // 5 minutes
  defaultLanguage: 'fr',
};
